import
{
    Component, Input
} from "@angular/core";
import { IProcessStep, ProcessViewModel } from "@tylertech/tyler-api-types";
@Component({
    selector: "processing-card",
    templateUrl: "./processingCard.tmpl.html",
    styleUrls: [
        "./processingCard.component.scss"
    ],
    standalone: false
})
export class ProcessingCardComponent
{
    @Input()
    entity: ProcessViewModel;

    @Input()
    enableLink: boolean;

    isProcessing: boolean = false;

    get steps(): IProcessStep[]
    {
        return this.entity.Steps;
    }
}
